<script>
  export let wp
  export let hideUser = false

  import { Link } from 'svelte-navigator'
  import { _ } from 'svelte-i18n'

  import { formatSeconds } from '../utils.js'
  import { currentUser } from '../oauth.js'
  import { tooltipable } from './tooltipable.js'

  import LinkedUserShort from './LinkedUserShort.svelte'
</script>

<div class="card h-100 shadow-sm">
  <div class="card-body">
    <h5 class="card-title wptitle">
      {#if wp.user.id == $currentUser.id}
        <Link to="/workoutplans/train/{wp.id}">
          {wp.title}
        </Link>
      {:else}
        <Link to="/workoutplans/view/{wp.id}">
          {wp.title}
        </Link>
      {/if}
      {#if wp.visibility == 'public'}
        <span
          class="badge bg-secondary"
          title={$_('workoutplancard.public')}
          use:tooltipable><i class="bi bi-globe" /></span
        >
      {/if}
      {#if wp.role}
        <span
          class="badge bg-secondary"
          title={$_('workoutplancard.shared')}
          use:tooltipable><i class="bi bi-people" /></span
        >
      {/if}
    </h5>
    {#if wp.description != ''}
      <p class="card-text" style="white-space: pre-line;">
        {wp.description}
      </p>
    {/if}
  </div>
  <ul class="list-group list-group-flush">
    {#if !hideUser}
      <li class="list-group-item">
        <LinkedUserShort user={wp.user} />
      </li>
    {/if}
    <li class="list-group-item">
      {$_('workoutplancard.trained_bodyparts')}:
      {#each wp.trained_bodyparts as bp (bp.id)}
        <span class="badge rounded-pill bg-light text-dark">{bp.name}</span>
      {/each}
    </li>
    <li class="list-group-item">
      {$_('workoutplancard.required_equipment')}:
      {#if wp.required_equipment.length > 0}
        {#each wp.required_equipment as equipment (equipment.id)}
          <span class="badge rounded-pill bg-light text-dark"
            >{equipment.name}</span
          >
        {/each}
      {:else}
        {$_('workoutplancard.required_equipment_none')}
      {/if}
    </li>
    <li class="list-group-item">
      {$_('workoutplancard.duration')}:
      {formatSeconds(wp.total_duration)}
    </li>
  </ul>
  <div class="card-footer">
    <div class="btn-group" role="group">
      {#if wp.user.id == $currentUser.id}
        <Link
          to="/workoutplans/train/{wp.id}"
          class="btn btn-primary"
          role="button"
          ><i class="bi bi-trophy" /> {$_('workoutplancard.train')}</Link
        >
        <Link
          to="/workoutplans/edit/{wp.id}"
          class="btn btn-secondary"
          role="button"
          ><i class="bi bi-pencil" /> {$_('workoutplancard.edit')}</Link
        >
      {:else}
        <Link
          to="/workoutplans/clone/{wp.id}"
          class="btn btn-secondary"
          role="button"
          ><i class="bi bi-journal-plus" /> {$_('workoutplancard.clone')}</Link
        >
        <Link
          to="/workoutplans/view/{wp.id}"
          class="btn btn-secondary"
          role="button"
          ><i class="bi bi-journal-text" /> {$_('workoutplancard.view')}</Link
        >
      {/if}
    </div>
  </div>
</div>

<style>
  .wptitle :global(a) {
    text-decoration: none;
    color: var(--bs-body-color);
  }

  .wptitle :global(a:hover) {
    color: var(--bs-primary);
  }
</style>
